import { DismantlingBayType } from "./DismantlingBay";
import { DefaultResponseWithData } from "./system";
import { FinancialDecision, VehicleComplexity, VehicleStatus } from "./Vehicle";

export enum VehicleProductionLine {
  MainLine = 0,
  OffLine = 1,
}

export interface IPlannerVehicleRow {
  id: string;
  vrm: string;
  stockNumber: string | null;
  combinedMake: string | null;
  combinedModel: string | null;
  bodyStyle: string | null;
  fuelType: string | null;
  driveType: string | null;
  complexity: VehicleComplexity;
  productionLine: VehicleProductionLine;
  locationId: string | null;
  locationName: string | null;
  arrivalDate: string | null;
  collectedOn: string | null;
  vehicleImageUrl: string | null;
  dismantlingBayId: string | null;
  plannedDismantlingOn: string | null;
  dismantlingBayOrder: number;
  partsRemoved: number;
  partsTotal: number;
  partsListValue: number;
  isJobComplete: boolean;
  financialDecision: FinancialDecision;
}

export interface IAllocateVehicleRequest {
  dismantlingBayId: string;
  plannedOn: string;
}

export interface IReorderBayRequest {
  dismantlingBayId: string;
  plannedOn: string;
  vehicleIds: string[];
}

// Returned by the planner lookup — used when a search finds nothing on screen and
// we need to report where the vehicle really is (typically the day it's booked in).
export interface IPlannerSearchResult {
  id: string;
  vrm: string;
  stockNumber: string | null;
  combinedMake: string | null;
  combinedModel: string | null;
  complexity: VehicleComplexity;
  status: VehicleStatus;
  locationName: string | null;
  dismantlingBayId: string | null;
  dismantlingBayName: string | null;
  bayType: DismantlingBayType | null;
  plannedDismantlingOn: string | null;
  isAwaitingDismantling: boolean;
}

export interface IPlannerSearchResponse
  extends DefaultResponseWithData<IPlannerSearchResult[]> {}

// Who each vehicle's parts are assigned to, for the dismantling line export.
export interface IPlannerPartAccount {
  vehicleId: string;
  categoryName: string;
  accountName: string;
}

export interface IPlannerPartAccountsResponse extends DefaultResponseWithData<IPlannerPartAccount[]> {}

export interface IPlannerVehicleRowsResponse extends DefaultResponseWithData<IPlannerVehicleRow[]> {}
export interface IPlannerVehicleRowResponse extends DefaultResponseWithData<IPlannerVehicleRow> {}

export type PlannerView = "Bays" | "ProductionLine";
export type PlannerColourBy = "Complexity" | "Age";
export type PlannerSort = "Oldest" | "Newest" | "Easiest" | "Hardest";
export type PlannerComplexityFilter = "All" | "Easy" | "Medium" | "Hard";
export type PlannerDayRange = 1 | 3 | 5 | 7;

export interface IPlannerDragItem {
  vehicleId: string;
  currentBayId: string | null;
  currentPlannedOn: string | null;
}
